import type { TooltipProps } from '@talos/kyoko';

export const MARKET_CARD_CONTROL_TOOLTIP_DELAY_MS = 1000;

export const MARKET_CARD_CONTROL_TOOLTIP_PROPS = {
  placement: 'bottom',
  delay: MARKET_CARD_CONTROL_TOOLTIP_DELAY_MS,
  hideDelay: 0,
} satisfies Pick<TooltipProps, 'placement' | 'delay' | 'hideDelay'>;
